import { Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { connect } from "react-redux";
import { userActionType as action } from './redux/user/user.action.type';
import jwt_decode from "jwt-decode";
import { Navigate } from "react-router-dom";
import pages from 'pages/index';
import Login from 'pages/Login';
import ChangePassword from 'pages/ChangePassword';
import WrapperComponent from './components/Wrapper';
import axios from './apis/axios';
import { GiWingedSword } from 'react-icons/gi';
import { logOutUser } from './redux/user/user.action';
import { setCurrentUser } from './redux/user/userSlice';
import MaintenancePage from 'pages/MaintenancePage';
import { getAllData } from 'apis/customApiHandler';
import io from 'socket.io-client';
import AnalyticsTracker from 'common/AnalyticsTracker';
// import {setCurrentUser} from 'redux/user/user.action'

const Routing = ({ socket, ...props }) => {
  const [currentUser, setCurrentUser] = useState(JSON.parse(localStorage.getItem("user")))
  const [reduxUser, setReduxUser] = useState(props?.user)
  const [isMaintenance, setIsMaintenance] = useState(null);

  const navigate = useNavigate();
  // console.log({currentUser, reduxUser})
  const onStorageUpdate = () => {
    const token = currentUser?.token
  }



  const parseJwt = () => {
    console.log("In token")
    const token = currentUser?.token
    if (token) {
      // console.log({token})
      const decode = jwt_decode(token)
      // console.log({decode});
      if (decode?.exp * 1000 <= new Date().getTime()) {
        props.logout(navigate)
        console.log('Time Expired');
      }
    }
  }

  useEffect(() => {
    parseJwt()
    // console.log("Emiting")
    // console.log("Socket", socket)
    // console.log("Emitting send message to the backend")
    // socket.emit("sendMessage", 2)
    // socket.emit("online", currentUser?._id)
    return () => socket.off('sendMessage');
  }, [currentUser])


  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    }
  }, []);

  const clearStorage = () => {
    const token = currentUser?.token
    setCurrentUser(null);
  }
  useEffect(() => {
    window.addEventListener("clearStorage", clearStorage);
    return () => {
      window.removeEventListener("clearStorage", clearStorage);
    }
  }, []);

  useEffect(() => {
    if (!reduxUser) {
      props.loginUser(currentUser)
      setReduxUser(currentUser)
    }
  }, [props?.user]);

  useEffect(() => {
    const checkMaintenanceStatus = async () => {
      try {
        const response = await getAllData('/version');
        console.log("response", response)
        const data = response

        setIsMaintenance(data.data[0].underMaintenance);
      } catch (error) {
        console.error("error", error);
        setIsMaintenance(false);
      }
    };

    checkMaintenanceStatus();
  }, []);

  // useEffect(() => {
  //   if(currentUser){
  //     console.log("online")
  //   }
  // }, [currentUser])

  useEffect(() => {
    // if (currentUser) {
      socket.on("connect", () => {
        console.log("✅ Connected to server:", socket.id);
      });

      socket.on("progressUpdate", (val, maxVal) => {
        console.log("📥 Received progressUpdate:", val, maxVal);
      });

      socket.emit("online", currentUser)

      return () => {
        socket.disconnect();
      };
    // }
}, [socket, currentUser]);



  return (
    isMaintenance ?
      <Routes>
        <Route path="/*" element={<MaintenancePage />} />
      </Routes> :
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/change-password" element={<ChangePassword />} />

        {pages.map((page) => (
          <Route
            key={page.path}
            path={page.path}
            element={
              page.auth ? (
                currentUser && Object.keys(currentUser).length ? (
                  <WrapperComponent>
                    <AnalyticsTracker moduleName={page.moduleName} />
                    <page.main socket={socket} />
                  </WrapperComponent>
                ) : (
                  <Navigate to="/login" replace />
                )
              ) : (
                <WrapperComponent>
                  <AnalyticsTracker moduleName={page.moduleName} />
                  <page.main socket={socket} />
                </WrapperComponent>
              )
            }
          />
        ))}
        </Routes>
      
  );
};

const mapStateToProps = (state) => {
  console.log({ state })
  return {
    // golbal user profile
    user: state.user?.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginUser: (user) => {
      console.log({ user })
      // dispatch({ type: action.SET_CURRENT_USER, payload: user });
      dispatch(setCurrentUser(user));
    },
    logout: (navigate) => {
      dispatch(logOutUser(navigate));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Routing);
